import OwnerProfile from "./OwnerProfile";

export default OwnerProfile